import { OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CrazyCallConfigService } from '../shared/services/crazycall-config.service';
import { AppConfigService } from '../shared/services/app-config.service';
import { TranslateService } from '@ngx-translate/core';
import { LeadGenerationConfigurationService } from '../shared/services/lead-generation-configuration.service';
import { getActiveProjectSelector } from '../projects/projects.reducer';
import { Store } from '@ngrx/store';
import { LeadGenerationCodeService } from '../shared/lead-generation-code.service';
import { AmplitudeService } from '../../shared/services/amplitude.service';
var InstallationComponent = /** @class */ (function () {
    function InstallationComponent(leadGenerationService, appConfigService, crazyCallConfigService, toastr, translate, store, leadGenerationCodeService, amplitudeService) {
        this.leadGenerationService = leadGenerationService;
        this.appConfigService = appConfigService;
        this.crazyCallConfigService = crazyCallConfigService;
        this.toastr = toastr;
        this.translate = translate;
        this.store = store;
        this.leadGenerationCodeService = leadGenerationCodeService;
        this.amplitudeService = amplitudeService;
        this.checkingInstallation = false;
        this.checkInstallationUrl = '';
        this.generatedCode = '';
    }
    InstallationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.logAmplitude('Init');
        this.generatedCode = this.leadGenerationCodeService.htmlCodeToInstall();
        this.store.select(getActiveProjectSelector).subscribe(function (config) {
            _this.config = config;
            _this.checkInstallationUrl = _this.checkInstallationUrl || config.domainName;
        });
    };
    InstallationComponent.prototype.copyCode = function () {
        var _this = this;
        this.logAmplitude('Copy code');
        this.translate.get('LEAD_GENERATION.TOAST.CODE_COPIED').subscribe(function (res) {
            _this.toastr.success(res);
        });
    };
    InstallationComponent.prototype.showCodeInstalledStatus = function (isCodeInstalled) {
        var _this = this;
        this.logAmplitude('Showing installed code status', { domain: this.checkInstallationUrl, isCodeInstalled: isCodeInstalled });
        var translationKey = isCodeInstalled ? 'CODE_INSTALLED' : 'CODE_NOT_INSTALLED';
        this.translate.get("LEAD_GENERATION.TOAST." + translationKey).subscribe(function (res) {
            isCodeInstalled ? _this.toastr.success(res) : _this.toastr.warning(res);
        });
    };
    Object.defineProperty(InstallationComponent.prototype, "installedCodeUrl", {
        get: function () {
            return this.config.domainName;
        },
        enumerable: true,
        configurable: true
    });
    InstallationComponent.prototype.handleCheckInstallationClick = function () {
        var _this = this;
        this.logAmplitude('Checking installed code', { domain: this.checkInstallationUrl });
        this.checkingInstallation = true;
        this.leadGenerationService.checkInstallation(this.checkInstallationUrl).subscribe(function (_a) {
            var installed = _a.installed;
            _this.showCodeInstalledStatus(installed);
        }, function () {
            _this.showCodeInstalledStatus(false);
        }, function () {
            _this.checkingInstallation = false;
        });
    };
    InstallationComponent.prototype.logAmplitude = function (message, event) {
        this.amplitudeService.logEvent("Panel:WebCall:Installation: " + message, event);
    };
    return InstallationComponent;
}());
export { InstallationComponent };
